import { render, staticRenderFns } from "./PainelTesoureiro.vue?vue&type=template&id=cc0b7670&"
import script from "./PainelTesoureiro.vue?vue&type=script&lang=js&"
export * from "./PainelTesoureiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports